// extracted by mini-css-extract-plugin
export default {"PortalLogo":"Banner_PortalLogo__VfzWq","NavItemsContainer":"Banner_NavItemsContainer__7PKaV","MenuItemStack":"Banner_MenuItemStack__z5Gz2"};